import { useTranslation } from "react-i18next";
import { useUncontrolledState } from "@tellescope/ui";
import { AttachDialogShell } from "./AttachDialogShell";
import { ManagedContentVariantContent } from "./ManagedContentVariantContent";
import { useManagedContentVariant } from "./useManagedContentVariant";
import type { AttachFileDialogContentProps } from "./types";

export const ManagedContentAttachDialog = ({
  children,
  open,
  onOpenChange,
  onAttachContent,
  selectedContentIds = [],
}: AttachFileDialogContentProps) => {
  const { t } = useTranslation("inbox");
  const [dialogOpen, setDialogOpen] = useUncontrolledState<boolean>({
    state: open ?? false,
    setState: onOpenChange
      ? (value) => onOpenChange(value instanceof Function ? value(open ?? false) : value)
      : undefined,
  });
  const logic = useManagedContentVariant({
    selectedContentIds,
    dialogOpen,
    onAttachContent,
  });

  const closeDialog = (newOpen: boolean) => {
    if (!newOpen) {
      logic.reset();
    }
    setDialogOpen(newOpen);
  };

  const handleAttach = () => {
    logic.attach();
    closeDialog(false);
  };

  return (
    <AttachDialogShell
      trigger={children}
      title={t("Select Content")}
      description={t("Choose content to attach")}
      open={dialogOpen}
      onOpenChange={closeDialog}
      selectedCount={logic.totalSelectedCount}
      onAttach={handleAttach}
      onCancel={() => closeDialog(false)}
      confirmTrackingId="attach-content-confirm"
    >
      <ManagedContentVariantContent logic={logic} />
    </AttachDialogShell>
  );
};
